import { render, staticRenderFns } from "./evaluation-dialog.vue?vue&type=template&id=bf8c9d1c&scoped=true"
import script from "./evaluation-dialog.vue?vue&type=script&lang=js"
export * from "./evaluation-dialog.vue?vue&type=script&lang=js"
import style0 from "./evaluation-dialog.vue?vue&type=style&index=0&id=bf8c9d1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf8c9d1c",
  null
  
)

export default component.exports